module.exports = __webpack_public_path__ + "assets/img/home-wz-light.6998a88d.png";